import type { IBannerRepository } from '../repository/IBannerRepository'
import type { Banner } from '../blocs/Banner'
import { NATIONAL_SCOPE } from '../utils/constantes'

export interface BannersForProductSheetUseCase {
  execute(
    isAuthenticated?: boolean,
    partnerId?: number,
    categories?: { label: string }[][],
    supplier?: string,
    product?: string,
  ): Promise<Banner | undefined>
}

export function getBannersForProductSheetUseCaseFactory(
  bannersRepository: IBannerRepository,
): BannersForProductSheetUseCase {
  async function execute(isAuthenticated, partnerId, categories, supplier, product) {
    const partnerScope = isAuthenticated ? String(partnerId) : NATIONAL_SCOPE

    return bannersRepository.getBannersForProductSheet(partnerScope).then((banners) => {
      return banners.find((banner) => {
        if (product && banner.productsFilter?.length) return banner.productsFilter?.includes(product)
        if (banner.supplierFilter && banner.categoryFilter)
          return categories[0].some((cat) => cat.label === banner.categoryFilter) && banner.supplierFilter === supplier

        if (banner.supplierFilter || banner.categoryFilter) {
          return categories[0].some((cat) => cat.label === banner.categoryFilter) || banner.supplierFilter === supplier
        }

        return false
      })
    })
  }

  return {
    execute,
  }
}
